import axios from 'axios';

export default {
    getInformation(cb, { clinicId, dealerId, clientToken }) {
        axios
        .get(`https://midwest-beltone-com-iframes-prod.azurewebsites.net/api/Clinic?ClinicId=${clinicId}&includeNextAvailableAppointment=true`, {
            headers: {
                Authorization: `Bearer ${clientToken}`,
                Dealer: dealerId
            }
        })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    },
};
